import development from './development.js';
import production from './production.js';

const env = 'development';
const enviroment = env === 'production' ? production : development;

export default enviroment;
